module.exports = __webpack_public_path__ + "static/media/video.e26e6528.webm";